export default __webpack_public_path__ + "static/media/FiraSans-Bold.ecb36ed4.woff2";